import { render, staticRenderFns } from "./AddNewVisit.vue?vue&type=template&id=4bfa3b6a&scoped=true&"
import script from "./AddNewVisit.vue?vue&type=script&lang=js&"
export * from "./AddNewVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfa3b6a",
  null
  
)

export default component.exports